
    import { Options, Vue } from "vue-class-component";
    import { namespace } from 'vuex-class';
    const authStore = namespace('auth');
    import CardRh from   "@/components/cards/ManzaCard.vue"
    import DisciplinaEspacoLocavelService from   "@/service/v1/sigap/DisciplinaEspacoLocavelService"
    import  SiteUtils   from '@/assets/ts/aplicacao/site';
    import KDataTable from   "@/components/datatable/newdatatable.vue"
    import { PerfilConfig } from "@/core/config/PerfisConfig";
    import {  Prop   } from 'vue-property-decorator';
    import  Cadastro from   "./_Cadastro.vue"
	import $ from "jquery"

    @Options({
        name: "DisciplinaEspacoIndex",
        components: {  CardRh , KDataTable , Cadastro },
    })
    export default class DisciplinaEspacoIndex extends Vue {

        @Prop( ) readonly disciplina!: any

        @authStore.Getter
        public perfis!: any

        public processando = false;
        public reloadDatatable = false ;
        public config: any = null;
        public service: any = null;
        public disciplinaId: any  = null ;


        get hasPermissao( ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.ChefeSTE,  PerfilConfig.AuxSTE ] ,  this.perfis);
        }

        public refreshTable(){
            setTimeout(() => {
                this.reloadDatatable = !this.reloadDatatable ;
            }, 300);
        }

        public apertouEnter(e){
            if(e.key === 'Enter' || e.keyCode === 13){
                this.refreshTable();
            }
        }

        created(){
            this.disciplinaId = this.$route.params.id;
            this.config = {  ajax: {} , columns: [] , columnDefs: [] , order: [] };
            this.service = new DisciplinaEspacoLocavelService();
            this.config.ajax = {
                url: this.service.getApiUrl()   ,
                data: function ( d ) {
                    const dados = {
                        "Skip": d.start,
                        "Take": d.length,
                        "disciplinaId": () => (document.querySelector('[data-kt-docs-table-filter="disciplinaId"]')! as HTMLInputElement).value ,
                        "search": d.search.value
                    }
                    return dados;
                }
            };
            this.config.order = [[1, 'asc']];
            this.config.columns = [
                { data: 'id', name: 'id' },
                { data: 'espacoLocavel.nome', name: 'espacolocavel' },
                { data: 'espacoLocavel.descricao', name: 'descricao' },
            ];
            if(this.hasPermissao){
                this.pushColunaAcoes()
                this.config.columnDefs = [
                    {
                        targets: 3 ,
                        render: ( row, type, val, meta ) => {
                            let texto = '' ;
                            let buttom = '' ;
                            for (var key in val) {  buttom = buttom + ' data-' + key + '="'+ val[key] +'"'  }
                            texto = texto + '<button class="btn btn-pmes-danger btn-sm" btn-excluir-espaco '+ buttom +' title="Excluir"><i class="fa fa-trash"></i></button>';
                            return texto;
                        },
                    },
                ];
            }
        }

        pushColunaAcoes(){
            this.config.columns.push({ data: 'id', name: 'id'  , orderable: false, searchable: false , class: 'text-center' });
        }


        public tableatualizada( event ) {
            $('[btn-excluir-espaco]').click(  (btn) => {
                const id =   $(btn.currentTarget).data('id');
                this.excluirModelo(id );
            });
        }


        protected excluirModelo( id  ) {
            SiteUtils.alertConfimacao('Confirma a Exclusão ','' ,
                () => {
                    this.processando = true;
                    setTimeout(() => {
                            this.service.excluir( id )
                        .then(response => {
                            this.reloadDatatable = !this.reloadDatatable;
                            SiteUtils.toastSucesso('Exclusao realizada com sucesso!!' );
                            this.processando = false;
                        })
                        .catch(error => {
                            this.processando = false;
                            SiteUtils.toastErro('Não foi possivel Excluir ' , error.data.message);
                        });
                    }, 10);
                }
            );
        }

    }

